export default [
  {
    id: 'married',
    name: 'Married',
  },
  {
    id: 'separated',
    name: 'Separated',
  },
  {
    id: 'unmarried',
    name: 'Unmarried',
  },
];



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/contact/resources/marital_status.js